import { useState } from "react";
import { AlertTriangle, Download, FileText, Gauge, Plus, Wand2 } from "lucide-react";
import { OCUPADO_TEXTO, fechaCorta, nivelPuntaje, versionTexto, type SeoTecnicoVista } from "../useSeoTecnico";

/** Teléfono: primero el informe y su descarga; las fuentes y la medición por plantilla van debajo, en tarjetas. */
export function SeoTecnicoMobile({ v }: { v: SeoTecnicoVista }) {
  const [ajuste, setAjuste] = useState("");
  const libre = v.ocupado === null;

  return (
    <div className="seot-m">
      {v.ocupado && <div className="detail-notice"><span className="button-spinner" /><span>{OCUPADO_TEXTO[v.ocupado]}</span></div>}
      {v.error && <div className="detail-notice is-danger"><AlertTriangle size={16} /><span>{v.error}</span></div>}
      {v.aviso && <div className="detail-notice"><span>{v.aviso}</span></div>}
      {v.sinMegaexport && (
        <div className="detail-notice"><AlertTriangle size={16} /><span>Sin megaexport de Semrush. Cárgalo en <a href="/semrush">Carga Semrush</a>.</span></div>
      )}

      <section className="seot-m-card">
        <span className="seot-m-eyebrow">Informe</span>
        {v.versionActual
          ? <strong className="seot-m-title">{versionTexto(v.versionActual)}</strong>
          : <strong className="seot-m-title">Sin informe generado</strong>}
        {v.informes.length > 1 && (
          <select className="seot-m-select" value={v.version ?? ""} onChange={(e) => v.setVersion(Number(e.target.value))} disabled={!libre}>
            {v.informes.map((i) => <option key={i.version} value={i.version}>{versionTexto(i)}</option>)}
          </select>
        )}
        <div className="seot-m-buttons">
          {v.urlDescarga && <a className="button button-ghost seot-m-btn" href={v.urlDescarga}><Download size={16} /> Descargar</a>}
          <button className="button button-primary seot-m-btn" type="button" onClick={v.generar} disabled={!libre || v.sinMegaexport}>
            <FileText size={16} /> {v.informes.length ? "Nuevo" : "Generar"}
          </button>
        </div>
        {v.versionActual?.alertas && (
          <div className="seot-alertas">
            <strong>Dudas antes de enviar</strong>
            <p>{v.versionActual.alertas}</p>
          </div>
        )}
      </section>

      {v.version != null && (v.html
        ? <iframe className="seot-m-preview" title="Vista previa del informe" sandbox="" srcDoc={v.html} />
        : <div className="seot-m-preview seot-preview-empty">Cargando informe…</div>)}

      {v.version != null && (
        <section className="seot-m-card">
          <label className="seot-m-eyebrow" htmlFor="seot-m-ajuste">Pedir ajuste</label>
          <textarea id="seot-m-ajuste" className="seot-m-textarea" value={ajuste} onChange={(e) => setAjuste(e.target.value)}
            rows={4} maxLength={4000} placeholder="Ej.: explica con un tooltip qué es una URL canónica." />
          <button className="button button-primary seot-m-btn seot-m-full" type="button" disabled={!libre || !ajuste.trim()}
            onClick={() => void v.ajustar(ajuste.trim()).then((ok) => ok && setAjuste(""))}>
            <Wand2 size={16} /> Aplicar ajuste
          </button>
        </section>
      )}

      <section className="seot-m-card">
        <span className="seot-m-eyebrow">Fuentes</span>
        <ul className="seot-m-sources">
          {v.fuentes.map((f) => (
            <li key={f.nombre}>
              <div><span>{f.nombre}</span><small>{f.detalle}</small></div>
              <strong>{f.fecha}</strong>
            </li>
          ))}
        </ul>
      </section>

      <section className="seot-m-card">
        <span className="seot-m-eyebrow">Tipos de página</span>
        <div className="seot-m-tipos">
          {v.filas.map((f, i) => (
            <div className="seot-m-tipo" key={i}>
              <label className="seot-m-check">
                <input type="checkbox" checked={f.marcada} onChange={(e) => v.editarFila(i, { marcada: e.target.checked })} />
                <input className="seot-m-input seot-m-strong" value={f.plantilla} onChange={(e) => v.editarFila(i, { plantilla: e.target.value })} placeholder="Tipo" aria-label="Tipo de página" />
              </label>
              <input className="seot-m-input" value={f.url} onChange={(e) => v.editarFila(i, { url: e.target.value })} placeholder="https://" aria-label="URL de muestra" />
              <div className="seot-m-scores">
                <span className={`seot-score ${nivelPuntaje(f.lighthouse?.performance)}`}>Rend. {f.lighthouse?.performance ?? "—"}</span>
                <span className={`seot-score ${nivelPuntaje(f.lighthouse?.seo)}`}>SEO {f.lighthouse?.seo ?? "—"}</span>
                <small>{f.lighthouse ? fechaCorta(f.lighthouse.fecha) : "Sin medir"}{f.paginas != null ? ` · ${f.paginas} págs.` : ""}</small>
              </div>
            </div>
          ))}
        </div>
        <div className="seot-m-buttons">
          <button className="button button-ghost seot-m-btn" type="button" onClick={v.agregarFila} disabled={!libre}><Plus size={16} /> URL</button>
          <button className="button button-primary seot-m-btn" type="button" onClick={v.correrLighthouse} disabled={!libre || !v.seleccion.length}>
            <Gauge size={16} /> Lighthouse ({v.seleccion.length})
          </button>
        </div>
      </section>
    </div>
  );
}
